import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import { getEditorPermissionForRoute, hasEditorPermission } from '@/config/editorPermissions'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/home',
    name: 'home',
    component: HomeView
  },
  {
    path: '/',
    name: 'login',
    component: () => import(/* webpackChunkName: "about" */ '../views/Login/sellerLoginPage.vue')
  },
  {
    path: '/admin2023',
    name: 'adminlogin',
    component: () => import(/* webpackChunkName: "about" */ '../views/Login/loginPage.vue')
  },
  {
    path: '/delivery2023',
    name: 'deliveryLogin',
    component: () => import(/* webpackChunkName: "about" */ '../views/Login/deliveryLoginPage.vue')
  },
  {
    path: '/category',
    name: 'category',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/product/categoryPage.vue')
  },
  {
    path: '/product',
    name: 'product',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/product/productPage.vue')
  },
  {
    path: '/add-product',
    name: 'add-product',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/product/createPage.vue')
  },
  {
    path: '/bulk-upload-products',
    name: 'bulk-upload-products',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/product/bulkUploadPage.vue')
  },
  {
    path: '/bulk-stock-price-update-products',
    name: 'bulk-stock-price-update-products',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/product/bulkStockPriceUpdatePage.vue')
  },
  {
    path: '/edit-product/:product_id',
    name: 'edit-product',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/product/editPage.vue'),
    props: true // Enables passing route params as props
  },
  {
    path: '/deletedProduct',
    name: 'deletedProduct',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/product/deletedProductPage.vue')
  },
  {
    path: '/sellerDeletedProduct',
    name: 'sellerDeletedProduct',
    component: () => import(/* webpackChunkName: "about" */ '../views/Seller/master_data/sellerDeletedProductPage.vue')
  },
  {
    path: '/subcategory',
    name: 'subcategory',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/product/subcategoryPage.vue')
  },
  {
    path: '/seller',
    name: 'seller',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/Seller/sellerPage.vue')
  },
  {
    path: '/pending-sellers',
    name: 'pending-sellers',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/Seller/pendingSellerPage.vue')
  },
  {
    path: '/review-sellers',
    name: 'review-sellers',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/Seller/reviewSellerPage.vue')
  },
  {
    path: '/rejected-sellers',
    name: 'rejected-sellers',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/Seller/rejectedSellerPage.vue')
  },
  {
    path: '/orderDetail',
    name: 'orderDetail',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/order/orderPage.vue')
  },
  {
    path: '/orderDetailAdmin',
    name: 'orderDetailAdmin',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/order/orderDetailPage.vue')
  },
  {
    path: '/orderList',
    name: 'orderList',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/order/orderListPage.vue')
  },
  {
    path: '/seller_profile',
    name: 'seller_profile',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/Seller/sellerProfile.vue')
  },
  {
    path: '/sellerDetail',
    name: 'sellerDetail',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/Seller/sellerDetailPage.vue')
  },
  {
    path: '/sellerBrand',
    name: 'sellerBrand',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/Seller/sellerBrandPage.vue')
  },
 
  {
    path: '/seller_manage_product',
    name: 'seller_manage_product',
    component: () => import(/* webpackChunkName: "about" */ '../views/Seller/master_data/manageProductPage.vue')

  },
  {
    path: '/seller_best_sellers',
    name: 'seller_best_sellers',
    component: () => import(/* webpackChunkName: "about" */ '../views/Seller/master_data/bestSellerPage.vue')

  },

  {
    path: '/seller_manage_product_item/:id',
    name: 'seller_manage_product_item',
    component: () => import(/* webpackChunkName: "about" */ '../views/Seller/master_data/manageItemPage.vue')

  },

  {
    path: '/seller_add_item',
    name: 'seller_add_item',
    component: () => import(/* webpackChunkName: "about" */ '../views/Seller/master_data/addItemPage.vue')

  },
  {
    path: '/customer',
    name: 'customer',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/customer/customerPage.vue')

  },
  //region start
  {
    path: '/manageRegion',
    name: 'manageRegion',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/order/manageRegionPage.vue')

  },
  //region end
  {
    path: '/editor_profile',
    name: 'editor_profile',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/editor/editorProfile.vue')
  },
  {
    path: '/editor',
    name: 'editor',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/editor/editorPage.vue')
  },
  {
    path: '/campangeCreate',
    name: 'campangeCreate',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/campange/campangeCreatePage.vue')

  },
  {
    path: '/campangeList',
    name: 'campangeList',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/campange/campangeListPage.vue')

  },
  {
    path: '/campangeProduct',
    name: 'campangeProduct',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/campange/campangeProductPage.vue')

  },
  {
    path: '/campangeDetail',
    name: 'campangeDetail',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/campange/campangeDetailPage.vue')

  },
  {
    path: '/sellerCampange',
    name: 'sellerCampange',
    component: () => import(/* webpackChunkName: "about" */ '../views/Seller/master_data/sellerCampangePage.vue')

  },

  {
    path: '/sellerJoinCampange',
    name: 'sellerJoinCampange',
    component: () => import(/* webpackChunkName: "about" */ '../views/Seller/master_data/joinSellerCampangePage.vue')

  },
  {
    path: '/seller_orderList',
    name: 'seller_orderList',
    component: () => import(/* webpackChunkName: "about" */ '../views/Seller/order/sellerOrderListPage.vue')
  },
  {
    path: '/questionAnswer',
    name: 'questionAnswer',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/question/questionPage.vue')
  },
  {
    path: '/questionAdmin',
    name: 'questionAdmin',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/question/questionAdminPage.vue')
  },
  {
    path: '/reviewAdmin',
    name: 'reviewAdmin',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/review/reviewAdminPage.vue')
  },
   {
    path: '/reviewSeller',
    name: 'reviewSeller',
    component: () => import(/* webpackChunkName: "about" */ '../views/Seller/review/reviewSellerPage.vue')
  },
  {
    path: '/answerAdmin',
    name: 'answerAdmin',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/question/answerAdminPage.vue')
  },
   {
    path: '/reviewDetailAdmin',
    name: 'reviewDetailAdmin',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/review/reviewDetailPage.vue')
  },
  {
    path: '/bannerPage',
    name: 'bannerPage',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/banner/bannerPage.vue')
  },
  {
    path: '/popup-ads',
    name: 'popup-ads',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/popup-ads/popupAdPage.vue')
  },
  {
    path: '/brandPage',
    name: 'brandPage',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/brand/brandPage.vue')
  },
  {
    path: '/marketPlacePage',
    name: 'marketPlacePage',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/MarketplaceService/marketPlacePage.vue')
  },
  {
    path: '/serviceAreaPage',
    name: 'serviceAreaPage',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/ServiceArea/serviceAreaPage.vue')
  },
   {
    path: '/largeItemTypePage',
    name: 'largeItemTypePage',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/largeItem/largeItemPage.vue')
  },
  {
    path: '/financePage',
    name: 'financePage',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/finance/financePage.vue')
  },
   {
    path: '/totalFinancePage',
    name: 'totalFinancePage',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/finance/totalFinancePage.vue')
  },
   {
    path: '/financeDetailPage',
    name: 'financeDetailPage',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/finance/financeDetailPage.vue')
  },
  {
    path: '/sellerFinancePage',
    name: 'sellerFinancePage',
    component: () => import(/* webpackChunkName: "about" */ '../views/Seller/finance/sellerFinanceDetailPage.vue')
  },
  {
    path: '/deliveryPage',
    name: 'deliveryPage',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/delivery/deliveryPage.vue')
  },
  {
    path: '/deliverySearchPage',
    name: 'deliverySearchPage',
    component: () => import(/* webpackChunkName: "about" */ '../views/Delivery/deliverySearchPage.vue')
  },
  {
    path: '/deliveryDetailPage',
    name: 'deliveryDetailPage',
    component: () => import(/* webpackChunkName: "about" */ '../views/Delivery/deliveryDetailPage.vue')
  },
  {
    path: '/deletedSeller',
    name: 'deletedSeller',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/Seller/deletedSellerPage.vue')
  },
  {
    path: '/seller-finance',
    name: 'seller-finance',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/finance/sellerFinancePage.vue')
  },
  {
    path: '/monthly-reports',
    name: 'monthly-reports',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/finance/monthlyReportsPage.vue')
  },
  {
    path: '/customer-finance',
    name: 'customer-finance',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/finance/customerFinancePage.vue')
  },
   {
    path: '/budgetReportPage',
    name: 'budgetReportPage',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/finance/budgetReportPage.vue')
  },

  {
    path: '/item-lists',
    name: 'item-lists',
    component: () => import('../views/Admin/product/itemListsPage.vue')
  },
  {
    path: '/promotion-events',
    name: 'promotion-events',
    component: () => import(/* webpackChunkName: "about" */ '../views/Seller/Promotion/promotionEventPage.vue')
  },
  {
    path: '/join-promotion-events/:promotion_id/',
    name: 'join-promotion-events',
    component: () => import(/* webpackChunkName: "about" */ '../views/Seller/Promotion/joinPromotionEventPage.vue'),
    props: true // Enables passing route params as props
  },

  {
    path: '/promotion-event-detail/:promotion_id/',
    name: 'promotion-event-detail',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin/Promotion/joinPromotionEventPage.vue'),
    props: true // Enables passing route params as props
  },

  {
    path: '/role-permissions',
    name: 'role-permissions',
    component: () => import(/* webpackChunkName: "about" */ '../views/Seller/role_permissions/indexPage.vue')
  },

  {
    path: '/customer-return-requests',
    name: 'customer-return-requests',
    component: () => import(/* webpackChunkName: "about" */ '../views/Seller/customer_return_requests/indexPage.vue')
  },
  {
    path: '/seller-user-supports',
    name: 'seller-user-supports',
    component: () => import(/* webpackChunkName: "about" */ '../views/Seller/user_supports/indexPage.vue')
  },
  {
    path: '/seller-user-supports/seller-agreement',
    name: 'seller-user-supports-agreement',
    component: () => import(/* webpackChunkName: "about" */ '../views/Seller/user_supports/SellerAgreementPage.vue')
  },
  {
    path: '/seller-chat',
    name: 'seller_chat',
    component: () => import(/* webpackChunkName: "about" */ '../views/Seller/chat/chatPage.vue')
  },
  {
    path: '/seller-chat/conversation/:conversationUuid',
    name: 'seller_chat_conversation',
    component: () => import(/* webpackChunkName: "about" */ '../views/Seller/chat/chatConversationPage.vue'),
    props: true
  },

  //admin layout
  {
    path: '/admin',
    children: [
      {
        path: 'promotion-events',
        name: 'admin-promotion-events',
        component: () => import('../views/Admin/Promotion/promotionEventPage.vue')
      },
      {
        path: 'promotion-codes',
        name: 'admin-promotion-codes',
        component: () => import('../views/Admin/PromotionCode/promotionCodePage.vue')
      },
      {
        path: 'referrals',
        name: 'admin-referrals',
        component: () => import('../views/Admin/referral/referralPage.vue')
      },
      {
        path: 'join-promotion-events/:promotion_id/',
        name: 'admin-join-promotion-events',
        component: () => import('../views/Admin/Promotion/joinPromotionEventPage.vue'),
        props: true
      },
      {
        path: 'customers/orders/:customer_id/',
        name: 'customer-order-lists',
        component: () => import('../views/Admin/customer/Order/indexPage.vue'),
        props: true
      },
      {
        path: 'mobile-notifications',
        name: 'mobile-notifications',
        component: () => import('../views/Admin/notification/notificationPage.vue')
      },
      {
        path: 'feature-settings',
        name: 'feature-settings',
        component: () => import('../views/Admin/feature-settings/indexPage.vue')
      },
      {
        path: 'admin-review-products',
        name: 'admin-review-products',
        component: () => import('../views/Admin/admin-review-products/indexPage.vue')
      },
      {
        path: 'product-audits',
        name: 'product-audits',
        component: () => import('../views/Admin/product/ProductAuditPage.vue')
      },
      {
        path: 'route-stats',
        name: 'admin-route-stats',
        component: () => import('../views/Admin/server/routeStatsPage.vue')
      },
    ]
  },

  {
    path: '/404',
    name: 'NotFound',
    component: () => import('../views/NotFoundPage.vue')
  },
  
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// router.beforeEach((to, from, next) => {
//   if (sessionStorage.getItem('Token') == null) next({ name: 'login' })
//   else next()
// })
// router.beforeEach((to, from, next) => {
//   if (sessionStorage.getItem('Token') == null) next({ name: 'login' })
//   else next()
// })
router.beforeEach((to, from,next) => {
  if (to.name != 'login' && to.name != 'adminlogin' && to.name != 'deliveryLogin' && sessionStorage.getItem('Token') == null) {
    // redirect the user to the login page
    next({name: 'login'})
    return
  }

  if (sessionStorage.getItem('getRole') === 'Editor') {
    const routeName = to.name == null ? '' : String(to.name)
    const safeEditorRoutes = ['editor_profile', 'NotFound']
    if (safeEditorRoutes.includes(routeName)) {
      next()
      return
    }

    const permissionId = getEditorPermissionForRoute(routeName)
    let editorPermissions = null
    try {
      const editor = JSON.parse(sessionStorage.getItem('getEditor') || 'null')
      editorPermissions = editor && editor.permissions
    } catch {
      editorPermissions = null
    }

    if (!permissionId || !hasEditorPermission(permissionId, editorPermissions)) {
      next({ name: 'editor_profile' })
      return
    }
  }

  next()
})


export default router
